import { cn } from "@/lib/utils";

// Últimas peças pequenas que ainda viviam no styles.css.

// Iniciais do responsável nas listas. `initial-avatar` fica no className: as
// linhas de prazo e os cartões do Kanban posicionam o avatar pelo nome
// (`.deadline-row > .initial-avatar`).
export const initialAvatarClass =
  "initial-avatar inline-grid h-[1.72rem] w-[1.72rem] place-items-center rounded-full border border-[var(--border-strong)] text-legenda text-[var(--text)]";

export const formErrorClass = "my-[0.35rem] text-legenda text-[var(--error)]";

// TUT-205b2 — a LISTA sobreviveu ao editor: é ela que enfileira os contatos
// secundários embaixo do principal na célula de `ContatosDaFicha`, hoje a
// única consumidora. Fica exportada porque a classe descreve um DESENHO e o
// componente é quem o aplica; as duas classes do EDITOR saíram junto com o
// `EmailFields`, porque classe exportada sem quem a use é a mesma dívida que
// o componente sem consumidor.
export const additionalEmailsListClass =
  "m-0 mt-[0.2rem] grid list-none gap-[0.15rem] p-0 text-corpo text-[var(--muted)]";

export const pageErrorClass = "[&>svg]:text-[var(--critical)]";

// Colunas que somem em telas menores. Ficam como classe porque a célula do
// cabeçalho e a do corpo precisam sumir juntas, e só o nome liga as duas.
export const columnCompanyClass = "column-company max-[980px]:hidden";

// Barra de rolagem discreta da navegação lateral.
export const sidebarScrollbarClass = cn(
  "[scrollbar-width:thin] [scrollbar-color:rgba(228,233,247,0.28)_transparent]",
  "[&::-webkit-scrollbar]:w-2 [&::-webkit-scrollbar-track]:bg-transparent",
  "[&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-thumb]:bg-[rgba(228,233,247,0.22)]",
  "[&::-webkit-scrollbar-thumb:hover]:bg-[rgba(228,233,247,0.36)]",
);

// Véu atrás do drawer: só existe onde a navegação vira drawer.
export const mainContentClass =
  "w-full px-[1.15rem] pb-8 pt-[1.2rem] outline-0 min-[1800px]:mx-auto min-[1800px]:max-w-[1680px] max-[720px]:px-[0.7rem] max-[720px]:pb-6 max-[720px]:pt-[0.9rem]";
